import { formatNumberMix } from '@/utils'
export default {
  data() { },
  methods: {
    setCardOptions(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('merits-board::detail::成交额(USD)'),
        count: data && this.$dataCheck(formatNumberMix(data.gmv, 2, '', '')),
        prefix: '$',
        down: data && data.gmvRatio ? data.gmvRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.gmvRatio, 2, '', '')),
        noDetail: true
      }
      list[1] = {
        title: this.$t('merits-board::detail::营销费用(USD)'),
        count: data && this.$dataCheck(formatNumberMix(data.marketingCosts, 2, '', '')),
        prefix: '$',
        down: data && data.marketingCostsRatio ? data.marketingCostsRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.marketingCostsRatio, 2, '', '')),
        noDetail: true
      }
      list[2] = {
        title: 'ROI',
        count: data && this.$dataCheck(formatNumberMix(data.roi, 2, '', '')),
        down: data && data.roiRatio ? data.roiRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.roiRatio, 2, '', '')),
        noDetail: true
      }
      list[3] = {
        title: this.$t('merits-board::detail::目标达成率'),
        count: data && this.$dataCheck(formatNumberMix(data.process, 2, '', '%')),
        rate: '',
        noDetail: true
      }
      return list
    },
    setTeamTable(data = []) {
      return {
        type: 'table',
        title: this.$t('merits-board::detail::团队详情'),
        ref: 'teamTable',
        height: '335px',
        cancelShadow: true,
        columns: Object.keys(data[0] || {}),
        tableData: data
      }
    },
    setCampTable(data = []) {
      return {
        type: 'table',
        title: this.$t('merits-board::detail::优化师详情'),
        ref: 'campTable',
        height: '335px',
        cancelShadow: true,
        columns: Object.keys(data[0] || {}),
        tableData: data
      }
    },
    setShopTable(data = []) {
      return {
        type: 'table',
        title: this.$t('merits-board::detail::店铺详情'),
        ref: 'shopTable',
        height: '335px',
        cancelShadow: true,
        columns: Object.keys(data[0] || {}),
        tableData: data
      }
    }
  }
}
